import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapMetricTileComponent } from './map-metric-tile.component';
import { DotSpinnerModule } from '../dot-spinner/dot-spinner.module';

@NgModule({
	imports: [
		CommonModule,
		DotSpinnerModule,
	],
	exports: [
		MapMetricTileComponent,
	],
	providers: [
	],
	declarations: [
		MapMetricTileComponent,
	],
})
export class MapMetricTileModule { }
